import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { notify } from 'js/actions/alert-actions';
import {
  list as listAssessments,
  load as loadAssessment,
} from 'js/actions/assessment-actions';
import {
  createBreakout,
  updateBreakout,
  deleteBreakout,
} from 'js/actions/breakout-actions';

export function useUpdateBreakouts({ assessmentId, assessmentKey, teamId }) {
  const dispatch = useDispatch();
  const [savingBreakouts, setSavingBreakouts] = useState(false);

  const handleUpdateBreakouts = useCallback(
    async (
      payload,
      {
        silent = false,
        isNew = false,
        deletedId,
        reorder,
        movedId,
        position,
      } = {}
    ) => {
      if (!deletedId && !reorder && (isNew || !payload?.id) && !assessmentKey) {
        dispatch(
          notify({
            type: 'danger',
            message: 'Could not save breakouts: assessment key is missing',
          })
        );
        return;
      }

      setSavingBreakouts(true);
      try {
        if (deletedId) {
          await dispatch(deleteBreakout(deletedId));
        } else if (reorder && movedId && position != null) {
          await dispatch(updateBreakout(movedId, { position }));
        } else if (isNew || !payload?.id) {
          await dispatch(
            createBreakout({
              assessment_key: assessmentKey,
              name: payload.name,
              question_set_key: payload.question_set_key,
              question_key: payload.question_key,
              grouping_mode: payload.grouping_mode,
              groups: payload.groups,
            })
          );
        } else if (payload?.id) {
          await dispatch(
            updateBreakout(payload.id, {
              name: payload.name,
              question_set_key: payload.question_set_key,
              question_key: payload.question_key,
              grouping_mode: payload.grouping_mode,
              groups: payload.groups,
            })
          );
        }
        await dispatch(loadAssessment(assessmentId));
        if (assessmentKey && teamId) {
          await dispatch(
            listAssessments({
              key: assessmentKey,
              team_id: teamId,
              full: true,
            })
          );
        }
        if (!silent) {
          dispatch(
            notify({
              type: 'success',
              message: 'Breakout saved',
            })
          );
        }
      } catch (e) {
        dispatch(
          notify({
            type: 'danger',
            message: 'Could not save breakout',
          })
        );
        throw e;
      } finally {
        setSavingBreakouts(false);
      }
    },
    [assessmentId, assessmentKey, dispatch, teamId]
  );

  return { handleUpdateBreakouts, savingBreakouts };
}
